import { dangerouslyGetFeatureGateSync } from '@trello/feature-gate-client';

let isEnabled: boolean | undefined;

export const isReactRoutingEnabled = () => {
  if (isEnabled === undefined) {
    isEnabled = dangerouslyGetFeatureGateSync('tplat_react_router');
  }
  return isEnabled;
};
